export default "__VITE_ASSET__052f9869__"